import React from 'react';

import { ContainerHeader } from '~components';
import { faMoneyBill } from '~components/icon';
import TabContainer, { Tab } from '~components/TabContainer';
import { ClientSignupsContainer } from '~direct-debits/components/client-signups';
import { ConnectionManager } from '~direct-debits/components/connection';
import { MandateMatchingContainer } from '~direct-debits/components/mandates';
import { PaymentBatchesContainer } from '~direct-debits/components/payment-batches';

const tabs: Tab[] = [
  {
    id: 'direct-debits-connection',
    title: 'Connection',
    component: ConnectionManager,
  },
  {
    id: 'direct-debits-client-signups',
    title: 'Client Signups',
    component: ClientSignupsContainer,
  },
  {
    id: 'direct-debits-mandate-matching',
    title: 'Mandate Matching',
    component: MandateMatchingContainer,
  },
  {
    id: 'direct-debits-payment-batches',
    title: 'Payment Batches',
    component: PaymentBatchesContainer,
  },
];

const DirectDebitsContainer: React.FC = () => (
  <div className="p-2">
    <ContainerHeader icon={faMoneyBill} iconSize="1x" className="info" dataCy="direct-debits-header">
      Direct Debits — GoCardless
    </ContainerHeader>
    <TabContainer tabs={tabs} setPageTitle={false} />
  </div>
);

export default DirectDebitsContainer;
